<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "@/components/widgets/profile";
import Earning from "@/components/widgets/earning";
import Stat from "@/components/widgets/stat";
import Transaction from "@/components/widgets/transaction";
import Emailsent from "@/components/widgets/emailsent";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
  },
  data() {
    return {
      title: "Pembayaran",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Default",
          active: true
        }
      ],
      data : [
        {
          picked: null
        }
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  <nav class="navbar navbar-expand-lg navigation sticky" id="navbar">
    <div class="container">
      <a class="navbar-logo" href="/">
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-dark" />
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-light" />
      </a>
    </div>
  </nav>

    <div class="row">
      <div class="col-xl-6">
        <div class="vertical-nav">
          <b-card-text>
            <div class="card"
                 style= "
                        	border-radius: 4px;
	                        box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                	        margin: 6rem auto 8.1rem auto;
                        " 
            >
              <b-card-body
                  style= "
                          padding: 55px 44px;
                         "
              >
                <div>
                  <p style="font-size:1em">Pesanan #GK0056</p>
                  <p style="font-size:1.7em">Rp<span class="blue-paideia"> 300.000</span></p><br>
                  <hr>
                </div>
                <div>
                  <p style="font-size:1em;">Virtual Account BCA</p>
                  <p style="color:#231f20; font-size:1.3em">Paideia</p>
                  <p style="font-size:1em">No. Virtual Account</p>
                  <p style="font-size:1.5em"><span>837 22 88 5555</span></p><br>
                  <hr>
                </div>
                <div>
                  <p style="font-size:1em;">Petunjuk Pembayaran</p>
                  <p style="color:#373334">Mohon melakukan pembayaran sebelum <b>3 November 2020, 14:15</b> (1x24 jam) melalui Virtual Account. Bila tidak, pesanan ini akan dibatalkan secara otomatis.</p>
                </div><br><br>
                  <div class="text-center">
                    <p style="font-size:1em;"><snap class="blue-paideia"><a>Klik Disini</a></snap> untuk kembali ke aplikasi</p>
                  </div>
              </b-card-body>
            </div>
          </b-card-text>
        </div>
      </div>
      <!-- end col -->
      
    </div>
    <!-- end row -->
  </Layout>
</template>